module.exports = __webpack_public_path__ + "static/media/sub.f35f1fcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub.jpg
// module id = 170
// module chunks = 0